import { render, staticRenderFns } from "./rpa.vue?vue&type=template&id=853e8f08&scoped=true"
import script from "./rpa.vue?vue&type=script&lang=js"
export * from "./rpa.vue?vue&type=script&lang=js"
import style0 from "./rpa.vue?vue&type=style&index=0&id=853e8f08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e8f08",
  null
  
)

export default component.exports